import { SubAdminRoleKeys } from "src/app/core/constants/constants";
import { MenuItem } from "./menu.model";

/** Flip to true to show Shuttles in the top nav and the job dock. The route and filter stay either way. */
export const SHOW_SHUTTLES_TAB = false;

/** Flip to true to show Settings in the top nav. Profile, password, and logout stay on the avatar. */
export const SHOW_SETTINGS_TAB = false;

/**
 * Change Log, API Log, and Airport API Log pages are built and read-only.
 * They stay hidden because those history-server GETs accept Entity.ADMIN only.
 * Set this to true after the server change in FEATURES.md.
 */
export const SHOW_ADMIN_LOGS = false;

export const MENU: MenuItem[] = [
  {
    id: 8,
    label: "Dispatch",
    short: "Dispatch",
    link: "/users/dispatcher-panel",
    icon: "mdi mdi-headset",
    isCollapsed: true,
    role: "dispatcher-panel",
    permission: "111111",
    key: SubAdminRoleKeys.DISPATCHER_PANEL
  },
  {
    id: 30,
    label: "Bookings",
    short: "Bookings",
    icon: "mdi mdi-calendar-check",
    isCollapsed: true,
    subItems: [
      {
        id: 2,
        label: "menu.running",
        link: "/users/history/running",
        role: "running",
        icon: "ri ri-riding-line",
        isCollapsed: true,
        permission: "101011",
        key: SubAdminRoleKeys.RUNNING_BOOKING
      },
      {
        id: 3,
        label: "menu.completed",
        link: "/users/history/completed",
        role: "completed",
        icon: "bx bx-calendar-check",
        isCollapsed: true,
        permission: "101011",
        key: SubAdminRoleKeys.COMPLETED_BOOKING
      },
      {
        id: 4,
        label: "menu.scheduled",
        link: "/users/history/scheduled",
        role: "scheduled",
        icon: "bx bx-calendar",
        isCollapsed: true,
        permission: "101011",
        key: SubAdminRoleKeys.SCHEDULED_BOOKING
      },
      {
        id: 5,
        label: "menu.cancelled",
        link: "/users/history/cancelled",
        role: "cancelled",
        icon: "bx bx-calendar-x",
        isCollapsed: true,
        permission: "101011",
        key: SubAdminRoleKeys.CANCELLED_BOOKING
      },
      {
        id: 11,
        label: "menu.recurring-bookings",
        link: "/users/recurring",
        role: "recurring",
        icon: "ri-repeat-line",
        isCollapsed: true,
        permission: "111111",
        key: SubAdminRoleKeys.RECURRING_BOOKING
      }
    ]
  },
  {
    id: 33,
    label: "Running",
    short: "Running",
    link: "/users/history/running",
    icon: "ri ri-riding-line",
    isCollapsed: true,
    role: "running",
    permission: "101011",
    key: SubAdminRoleKeys.RUNNING_BOOKING
  },
  {
    id: 9,
    label: "V-Track",
    short: "V-Track",
    link: "/users/vehicle-tracking",
    icon: "mdi mdi-account-group",
    isCollapsed: true,
    role: "vehicle-tracking",
    permission: "111111",
    key: SubAdminRoleKeys.VEHICLE_TRACKING
  },
  {
    id: 34,
    label: "Logs",
    short: "Logs",
    icon: "ri-file-list-line",
    isCollapsed: true,
    subItems: [
      {
        id: 341,
        label: "Exception Logs",
        short: "Exception Logs",
        link: "/users/exception",
        icon: "ri-file-list-line",
        isCollapsed: true,
        role: "exception",
        permission: "100011",
        key: SubAdminRoleKeys.EXCEPTION
      },
      {
        id: 342,
        label: "Block List Logs",
        short: "Block List Logs",
        link: "/users/block-list-logs",
        icon: "mdi mdi-account-cancel",
        isCollapsed: true,
        role: "exception",
        permission: "100011",
        key: SubAdminRoleKeys.EXCEPTION
      },
      {
        id: 346,
        label: "Booking Logs",
        short: "Booking Logs",
        link: "/users/booking-logs",
        hidden: !SHOW_ADMIN_LOGS,
        icon: "ri-file-list-line",
        isCollapsed: true,
        role: "exception",
        permission: "100011",
        key: SubAdminRoleKeys.EXCEPTION
      },
      {
        id: 343,
        label: "Change Log",
        short: "Change Log",
        link: "/users/change-log",
        hidden: !SHOW_ADMIN_LOGS,
        icon: "ri-file-list-line",
        isCollapsed: true,
        role: "exception",
        permission: "100011",
        key: SubAdminRoleKeys.EXCEPTION
      },
      {
        id: 344,
        label: "API Log",
        short: "API Log",
        link: "/users/api-log",
        hidden: !SHOW_ADMIN_LOGS,
        icon: "ri-file-list-line",
        isCollapsed: true,
        role: "exception",
        permission: "100011",
        key: SubAdminRoleKeys.EXCEPTION
      },
      {
        id: 345,
        label: "Airport API Log",
        short: "Airport API Log",
        link: "/users/airport-api-log",
        hidden: !SHOW_ADMIN_LOGS,
        icon: "ri-file-list-line",
        isCollapsed: true,
        role: "exception",
        permission: "100011",
        key: SubAdminRoleKeys.EXCEPTION
      }
    ]
  },
  {
    id: 31,
    label: "Shuttles",
    short: "Shuttles",
    link: "/users/create-booking",
    hidden: !SHOW_SHUTTLES_TAB,
    icon: "mdi mdi-bus",
    isCollapsed: true,
    role: "create-booking",
    permission: "111111",
    key: SubAdminRoleKeys.BOOK_RIDE
  },
  {
    id: 32,
    label: "Reports",
    short: "Reports",
    link: "/users/history/completed",
    icon: "mdi mdi-chart-box",
    isCollapsed: true,
    role: "completed",
    permission: "101011",
    key: SubAdminRoleKeys.COMPLETED_BOOKING
  },
  {
    id: 50,
    label: "Settings",
    short: "Settings",
    hidden: !SHOW_SETTINGS_TAB,
    icon: "mdi mdi-cog",
    isCollapsed: true,
    subItems: [
      {
        id: 0,
        label: "menu.profile",
        short: "Profile",
        icon: "mdi mdi-account-circle",
        isCollapsed: true,
        link: "/users/profile",
        role: "profile",
        permission: "100011",
        key: SubAdminRoleKeys.PROFILE
      },
      {
        id: 10,
        label: "menu.block-list",
        short: "Block",
        link: "/users/block-list",
        icon: "mdi mdi-account-cancel",
        isCollapsed: true,
        role: "block-list",
        permission: "111111",
        key: SubAdminRoleKeys.BLOCK_LIST
      },
      {
        id: 6,
        label: "menu.exception",
        short: "Issues",
        link: "/users/exception",
        role: "exception",
        icon: "ri-file-list-line",
        permission: "100011",
        key: SubAdminRoleKeys.EXCEPTION
      }
    ]
  }
];
